<template>
  <div :class="{ 'my-box': isReceived, 'other-box': !isReceived}">
    <p
      class="message"
      :style="{
        background: isReceived ? color.balloonMy : color.balloonOtr + '!important',
        color: autoColor(isReceived ? color.balloonMy : color.balloonOtr),
        filter: shadowStyle(color.shadowType),
      }"
      v-html="
        $sanitize(convertMesasge(content, isReceived ? color.balloonMy : color.balloonOtr))
      "
    ></p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
// 外部関数
import { autoColor, shadowStyle, convertMesasge } from '@/functions/balloonFunc'

export default {
  name: 'MessageViewParts',
  props: ['subject', 'content', 'color', 'isReceived'],
  methods: {
    autoColor(c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle(t) {
      return shadowStyle(t)
    },
    /* XSSを防ぐためにタグが来たらerrorで返す */
    convertMesasge(m, c) {
      let color = hex2rgb(c)
      return convertMesasge(m, color)
    },
  },
}
</script>

<style scoped>
.message {
  text-align: left;
  padding: 12px 16px;  /* 上下のpaddingを少し減らし、左右は維持 */
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 18px;  /* より丸みを持たせる */
  font-size: 95%;  /* fontsize up */
  line-height: 1.4;  /* 読みやすさのために行間を調整 */
  white-space: pre-wrap;
  transition: 0.7s;
  margin-bottom: 8px;  /* メッセージ間の間隔を追加 */
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/MessageViewParts.vue